import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "toggle-icon" }
const _hoisted_2 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

import { computed } from 'vue'
import { useThemeStore } from '@/stores/theme'


export default /*@__PURE__*/_defineComponent({
  __name: 'ThemeToggle',
  setup(__props) {

const themeStore = useThemeStore()

const isDark = computed(() => themeStore.isDark)

const toggleTheme = () => {
  themeStore.toggleMode()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "theme-toggle",
    onClick: toggleTheme
  }, [
    _createElementVNode("div", _hoisted_1, [
      (isDark.value)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[0] || (_cache[0] = [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "5",
              stroke: "currentColor",
              "stroke-width": "2"
            }, null, -1),
            _createElementVNode("path", {
              d: "M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round"
            }, null, -1)
          ])))
        : (_openBlock(), _createElementBlock("svg", _hoisted_3, _cache[1] || (_cache[1] = [
            _createElementVNode("path", {
              d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ])))
    ])
  ]))
}
}

})